<template>
  <div class="package-cover">
    <img
      v-if="packageStyle.icon.type === 'imgv2'"
      class="package-cover__imagev2"
      :src="packageStyle.icon.content"
    />
    <Img
      v-else-if="packageStyle.icon.type === 'img'"
      :name="packageStyle.icon.content"
      class="package-cover__image"
    />
    <span
      v-else-if="packageStyle.icon.type === 'emoji'"
      class="package-cover__emoji"
    >
      {{ packageStyle.icon.content }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { PackageStyle } from '@/api/package-source'
import { computed } from 'vue'

const props = defineProps<{
  packageStyle: PackageStyle
  size: number
  borderRadius?: number
  transparentBackgroud?: boolean
}>()

const backgroundColorVar = computed(() => {
  return props.transparentBackgroud
    ? 'transparent'
    : `var(--${props.packageStyle.themeColor}-300)`
})
const sizeVar = computed(() => {
  return `${props.size}px`
})
const iconSizeVar = computed(() => {
  return `${Math.ceil(props.size * 0.55)}px`
})
const borderRadiusVar = computed(() => {
  return props.borderRadius ? `${props.borderRadius}px` : '0'
})
</script>

<style scoped>
.package-cover {
  display: flex;
  align-items: center;
  justify-content: center;
  width: v-bind('sizeVar');
  height: v-bind('sizeVar');
  overflow: hidden;
  background-color: v-bind('backgroundColorVar');
  border-radius: v-bind('borderRadiusVar');
}

.package-cover__imagev2 {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.package-cover__image {
  height: v-bind('iconSizeVar');
  width: v-bind('iconSizeVar');
  /* 这里不额外设置一遍的话，老版的img类型的图标加载时会显示一个色块 */
  background-color: v-bind('backgroundColorVar');
}

.package-cover__emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: v-bind('iconSizeVar');
}
</style>
